// removed by extract-text-webpack-plugin
module.exports = {"PackageSummary":"_2OuPNShya6a0t9oxb-i3Ye","list":"_2wWCuZ-J9z6aYBXvr-cqZe","consList":"_16Q6NBtveHu_W2eyfOjMP-","promotedText":"_2p5IpamRrwMx51VUnilsl1"};


//////////////////
// WEBPACK FOOTER
// ./app/client/bundles/EventSubmission/components/PackageSummary.scss
// module id = 1565
// module chunks = 0